import React, { ComponentProps, forwardRef } from 'react';
import { Alert as AlertMUI } from '@mui/material';

import { SHAPE_CIRCULAR, SHAPE_SQUARE } from '@/mui/constants';

import type { ShapeProp } from '@/mui/types';

export type AlertProps = ComponentProps<typeof AlertMUI> & {
  shape?: ShapeProp;
};

/**
 * !IMPORTANT: MUI developers forgot to add generic for the component/ref that why we can't
 * use component="a/section ...." in typescript without // @ts-expect-error MUI generic types issue
 *
 * example:

  const anchorRef = useRef<HTMLAnchorElement>(null);

  <MuiAlert
    component="a"
    // @ts-expect-error MUI generic types issue
    ref={anchorRef}
  >
  ...
  </MuiAlert>
 */
const Alert = forwardRef<HTMLDivElement, AlertProps>((props, ref) => {
  const { shape, sx, ...rest } = props;

  return (
    <AlertMUI
      ref={ref}
      {...rest}
      sx={{
        borderRadius:
          // eslint-disable-next-line no-nested-ternary
          shape === SHAPE_SQUARE
            ? 0
            : shape === SHAPE_CIRCULAR
              ? (theme) => theme.shape.borderRadiusCircular
              : undefined,
        ...sx,
      }}
    />
  );
});

export default Alert;
